export default "__VITE_ASSET__DTMd7I6y__"